import { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import TcmProjectForm from "./TcmProjectForm";
import { ROUTE_TCM_PROJECTS } from "../Routes/Routes";
import { useNavigate } from "react-router-dom";

const AddTcmProject = () => {
    const { user } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({
        "Id": 0,
        "BuildingId": 0,
        "ProjectDescription": "",
        "ProjectStartDate": "",
        "ProjectEndDate": "",
        "Comments": "",
        // "CreatedBy": user.email,
        // "CreatedDate": null,
        // "UpdatedBy": null,
        // "UpdatedDate": null,
        "TCMCostEstimates": []
    });
    const navigate = useNavigate();
    
    useEffect(() => {
        const permissions = user.role.ModulePermissions?.filter(module => { return (module.Page === ROUTE_TCM_PROJECTS.module) })
        if (!permissions?.filter(module => { return (module.Create) }).length > 0) 
        {
            navigate(-1);
        }
    }, []);
    return (
        <>
            <h4>Add TCM Project</h4>
            <TcmProjectForm
                data={data}
                isLoading={isLoading}
                create={true}
            />
        </>
    )
}

export default AddTcmProject;